const location = window.location.origin;
// export function getAPIDomain(): string {
//   const developmentDomain = window.localStorage.getItem('Capability:ApplicationFrame')
//   if (developmentDomain) return developmentDomain
//   if (location.indexOf('localhost') >= 0) return 'http://localhost:7066'
//   else {
//     return process.env.API_DOMAIN || ''
//   }
// }
export function getAPIDomain() {
    const domain = process.env.API_DOMAIN; //This only is defined when running with webpack serve
    if (domain)
        return domain;
    //@ts-ignore
    return window.APPFRAME_URL || '';
}
export function getAPI() {
    const domain = getAPIDomain();
    return `${domain}/api`;
}
let msalConfig = {
    clientId: '',
    tenantId: '',
    scopes: [''],
    redirectUri: '',
    scope: {},
};
export function updateConfig(config) {
    msalConfig = config.authentication;
}
export function getMSALConfiguration() {
    return msalConfig;
}
export const getScopes = (target) => {
    return msalConfig.scope[target];
};
